import { render, staticRenderFns } from "./StatisticCall.vue?vue&type=template&id=2963ee15&scoped=true&"
import script from "./StatisticCall.vue?vue&type=script&lang=js&"
export * from "./StatisticCall.vue?vue&type=script&lang=js&"
import style0 from "./StatisticCall.vue?vue&type=style&index=0&id=2963ee15&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2963ee15",
  null
  
)

export default component.exports